__turbopack_context__.v({
  "container": "AddressAutocomplete-module-scss-module__QtwRVa__container",
  "dropdown": "AddressAutocomplete-module-scss-module__QtwRVa__dropdown",
  "emptyItem": "AddressAutocomplete-module-scss-module__QtwRVa__emptyItem",
  "error": "AddressAutocomplete-module-scss-module__QtwRVa__error",
  "hasError": "AddressAutocomplete-module-scss-module__QtwRVa__hasError",
  "highlighted": "AddressAutocomplete-module-scss-module__QtwRVa__highlighted",
  "hint": "AddressAutocomplete-module-scss-module__QtwRVa__hint",
  "icon": "AddressAutocomplete-module-scss-module__QtwRVa__icon",
  "input": "AddressAutocomplete-module-scss-module__QtwRVa__input",
  "inputWrapper": "AddressAutocomplete-module-scss-module__QtwRVa__inputWrapper",
  "labelRow": "AddressAutocomplete-module-scss-module__QtwRVa__labelRow",
  "loadingItem": "AddressAutocomplete-module-scss-module__QtwRVa__loadingItem",
  "option": "AddressAutocomplete-module-scss-module__QtwRVa__option",
  "optionText": "AddressAutocomplete-module-scss-module__QtwRVa__optionText",
  "required": "AddressAutocomplete-module-scss-module__QtwRVa__required",
  "spin": "AddressAutocomplete-module-scss-module__QtwRVa__spin",
  "spinner": "AddressAutocomplete-module-scss-module__QtwRVa__spinner",
  "title": "AddressAutocomplete-module-scss-module__QtwRVa__title",
});
